import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from 'src/app/api.service';
import { GlobalServices } from 'src/app/global.services';

@Component({
  selector: 'app-newsletter-new',
  templateUrl: './newsletter-new.component.html',
  styleUrls: ['./newsletter-new.component.scss']
})
export class NewsletterNewComponent implements OnInit {

  constructor(
    public apiService: ApiService,
    private fb: FormBuilder,
    private globalservice: GlobalServices
    ) {
    this.emailForm = this.fb.group({
      email:[null,[Validators.required,checkValidatePssword.bind(this)]]
    })
    function checkValidatePssword(controls:AbstractControl):{passwordCheck:boolean}{
      let password = controls.value;
      if(password){
        if((password.indexOf('@')>-1) && (password.indexOf('.')>-1) && (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(password)) ){
          return null;
        }else{
          return {passwordCheck:true};
        }
      }
      return null;
    }
   }

  ngOnInit(): void {
  }


  get f(){return this.emailForm.controls;}

  public triggerCloseEvent() {
    this.showAlert = false;
  }

  public showAlert: boolean = false;
  public responseMessage: string = "";
  public submitted:boolean = false;
  mode:any;
  emailForm:FormGroup;
  submit(){
    this.submitted = true;
    if (this.emailForm.valid) {
      let urlSubscribe = "global/newsletter";
      let data = { email: this.emailForm.value.email};
    this.mode = 'indeterminate';
      this.apiService.postFormData(urlSubscribe, data).subscribe(res => {
        this.mode = 'determinate';
        this.showAlert = true;
        this.responseMessage = res.message;        
        this.submitted = false;
        this.emailForm.reset();  
      });
    } else {
      return;
    }
  }
}
